// firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const isLocalHost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const resolvedAuthDomain =
  !isLocalHost && typeof window !== 'undefined'
    ? window.location.host
    : process.env.VUE_APP_FIREBASE_AUTH_DOMAIN;

// Firebase 설정 - 환경 변수를 사용하여 설정 값 주입
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: resolvedAuthDomain,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
};

// Firebase 초기화
const app = initializeApp(firebaseConfig);

// Firebase 서비스 초기화
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);

let resolveAuthReady;
const authReadyPromise = new Promise((resolve) => {
  resolveAuthReady = resolve;
});

const unsubscribeAuthReady = onAuthStateChanged(auth, () => {
  if (resolveAuthReady) {
    resolveAuthReady();
    resolveAuthReady = null;
  }
  unsubscribeAuthReady();
});

export { auth, authReadyPromise, db, functions };
